import * as React from 'react'
import { Row } from 'antd'
import { useIntl } from 'react-intl'
import moment from 'moment'
import { isMobile } from 'react-device-detect'
import { isRtl } from '../../config/locales'
import styles from './TimeWindow.module.scss'
import { DeliveryStatus, ValidDeliveryStatuses } from '../../store/DeliveryTracking/types'
import { FadingView } from '../FadingView/FadingView'

interface TimeWindowProps {
  scheduledAt: moment.Moment
  deliverFrom: moment.Moment
  deliverUntil: moment.Moment
  enableReschedule: boolean
  status: DeliveryStatus
  onRescheduleClick?: VoidFunctionType
  show: boolean
  color: string
}

const TimeWindow = (props: TimeWindowProps) => {
  const style: CSSStyleDeclaration = document.documentElement.style
  const { formatMessage } = useIntl()

  const {
    scheduledAt,
    deliverFrom,
    deliverUntil,
    enableReschedule,
    status,
    onRescheduleClick,
    show,
    color,
  } = props
  style.setProperty('--reschedule-button-color', color)
  const translate = (id: string, values: any = {}) => formatMessage({ id }, values)

  let date = ''
  let timeWindow = ''
  const now = moment()
  const valid = (scheduledAt.isValid()) && ValidDeliveryStatuses.includes(status)
  if (valid) {
    const scheduledAtCopy = scheduledAt.clone()
    if (now.isSame(scheduledAtCopy, 'day')) {
      date = translate('today')
    } else if (now.isSame(scheduledAtCopy.subtract(1, 'day'), 'day')) {
      date = translate('tomorrow')
    } else if (now.isSame(scheduledAtCopy.add(2, 'day'), 'day')) {
      date = translate('yesterday')
    } else {
      date = scheduledAt.format('DD/MM/YY')
    }
  }
  if (deliverFrom.isValid()) {
    timeWindow = deliverFrom.format('HH:mm')
    if (deliverUntil.isValid()) {
      timeWindow += ` - ${deliverUntil.format('HH:mm')}`
    }
  }
  const direction = isRtl() ? 'rtl' : 'ltr'
  const title = translate('est_delivery_time')
  const rescheduleButtonText = translate('reschedule')

  return (
    <FadingView pose={show && valid ? 'visible' : 'hidden'}>
      <Row style={{ direction }} className={styles.title}>{ title }</Row>
      <Row style={{ direction }} className={styles.timeWindowText}>
        {date}
        {' '}
        {timeWindow && translate('between')}
        {' '}
        {isMobile && timeWindow && <br />}
        {timeWindow}
      </Row>
      {enableReschedule && (
        <Row style={{ direction }} className={styles.rescheduleButton}>
          <a onClick={onRescheduleClick} role="button">{ rescheduleButtonText }</a>
        </Row>
      )}
    </FadingView>
  )
}

export default TimeWindow
